import React from 'react';
import classes from './notification.module.css';
import cn from 'classnames';
import { getCheckSourceIcon } from '../../../../utility/fireboardUtil';
import { NotificationTypes } from '@constants/enums/notificationTypes';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const Table = ({
  notificationTableData,
  acknowledgeNotification,
  notificationGoAndDismiss,
  isVenue,
}) => {
  const columns = [
    ...(isVenue
      ? [{ Header: FLABEL().NOTIFICATION_STORE, accessor: 'store', style: 'col-2' }]
      : []),
    { Header: FLABEL().NOTIFICATION_TYPE, accessor: 'type', style: 'col-1' },

    { Header: FLABEL().NOTIFICATION_TIME, accessor: 'time', style: 'col-2' },
    {
      Header: FLABEL().NOTIFICATION_MESSAGE,
      accessor: 'message',
      style: isVenue ? 'col-4 px-0 text-left' : 'col-6 px-0 text-left',
    },
    { Header: FLABEL().NOTIFICATION_ACTIONS, accessor: 'buttons', style: 'col-3' },
  ];

  const showGoAndDismiss = notification => {
    if (notification.notificationTypeId === NotificationTypes.NEW_ORDER) {
      return true;
    }
    return false;
  };
  const channelColor = 'var(--primary-icon-color)';
  return (
    <div className={cn(classes.container, 'fs-12 h-100')}>
      <div
        className={cn(classes.tableHeader, 'row mx-0 align-items-center my-3')}
      >
        {columns.map(col => (
          <div className={cn(col.style, 'text-center')}>{col.Header}</div>
        ))}
      </div>

      <div className={cn(classes.notificationList)}>
        {notificationTableData?.length > 0 ? (
          notificationTableData.map(row => (
            <div
              key={row?.notification?.id}
              className={cn(
                classes.notificationBody,
                'row mx-0 mb-1 align-items-center'
              )}
            >
              {columns.map((col, cIndex) => {
                let cellValue = row[col.accessor];

                if (col.accessor === 'type') {
                  cellValue = getCheckSourceIcon(
                    row?.notification?.data?.sourceType,
                    channelColor
                  );
                }
                if (col.accessor === 'buttons') {
                  cellValue = (
                    <div
                      className={cn(
                        'col-12 px-0 d-flex align-items-center justify-content-end'
                      )}
                    >
                      {!showGoAndDismiss(row.notification) ? null : (
                        <div className="col-6 pl-0 pr-1">
                          <button
                            className={cn(
                              classes.actionButtons,
                              'col-12 fw-500'
                            )}
                            onClick={() =>
                              notificationGoAndDismiss(row?.notification)
                            }
                          >
                            {FLABEL().NOTIFICATION_GO_DISMISS}
                          </button>
                        </div>
                      )}
                      <div className="col-6 pr-0 pl-2">
                        <button
                          className={cn(classes.actionButtons, 'col-12 fw-500')}
                          onClick={() =>
                            acknowledgeNotification(row?.notification)
                          }
                        >
                          {FLABEL().NOTIFICATION_DISMISS}
                        </button>
                      </div>
                    </div>
                  );
                }

                return (
                  <div className={cn(col.style, classes.cell, 'text-center')}>
                    {cellValue}
                  </div>
                );
              })}
            </div>
          ))
        ) : (
          <div className={cn('h-100 d-flex justify-content-center align-items-center', classes.noRecord)}>
            {FLABEL().NOTIFICATION_NO_NOTIFICATIONS_AVAILABLE}
          </div>
        )}
      </div>
    </div>
  );
};

export default Table;
